import { MobileModal } from './mobile-modal';
import { ModalPortal } from './modal-portal';
import { ModalProps } from './modal.interface';
import React from 'react';
import { StyledModal } from './modal.styles';
import { useIsSmallViewportWidth } from 'hooks/use-is-small-viewport-width.hook';

const maxWidthVariants: Record<NonNullable<ModalProps['variant']>, number> = {
  small: 424,
  normal: 612,
  wide: 984,
};

export const Modal = ({ children, onClose: handleClose, variant = 'normal' }: ModalProps): JSX.Element => {
  const isSmallViewportWidth = useIsSmallViewportWidth();

  return (
    <ModalPortal>
      {isSmallViewportWidth ? (
        <MobileModal>{children}</MobileModal>
      ) : (
        <StyledModal
          opened
          maxWidth={maxWidthVariants[variant]}
          onClose={handleClose}
          dataTestId="modal-window"
          data-cy="modal-window"
          variant={variant}
        >
          {children}
        </StyledModal>
      )}
    </ModalPortal>
  );
};
